import { render } from "./ExperienceForm.vue?vue&type=template&id=3d8ffc58"
import script from "./ExperienceForm.vue?vue&type=script&lang=js"
export * from "./ExperienceForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__